import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResCargueExcelFivi } from 'src/app/modelos/ResCargueExcelFivi';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { CarguemasivofuenteService } from 'src/app/servicios/fuentes/carguemasivo/carguemasivofuente.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-carguemfivi',
  templateUrl: './carguemfivi.component.html',
  styleUrls: ['./carguemfivi.component.css']
})
export class CarguemfiviComponent implements OnInit, AfterViewInit {

  uploadedFiles : Array<File>;

  btnCargar : Boolean;
  cargar : Boolean;
  btnContinuar : Boolean;
  continuar : Boolean;
  errorcargue : Boolean;
  spinner : Boolean;

  idFuente : BigInteger;
  idUsuarioCarga : String;
  RolUsuarioCarga : String;

  file: any;
  contenidoDocumento: string;
  RespuestaCargueMasivo: ResponseCargueI = new ResponseCargueI;

  PeriodoActivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  EstadoInfomacionFuente : EstadoInfoFiviI = new EstadoInfoFiviI;

  ReporPedRefSi : Boolean;
  ReporPedRefNo : Boolean;
  @ViewChild('openmodalperidoact') openmodalperidoact: ElementRef;
  @ViewChild('closemodalperidoact') closemodalperidoact: ElementRef;

  pdfUrl: string = 'assets/Formatos/Guia diligenciamiento_FIVI.pdf';
  xlsxUrl: string = 'assets/Formatos/Plantilla FIVI Fuentes.xlsx';

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private carguemasivofuenteService: CarguemasivofuenteService
  ) { }

  ngOnInit(): void {
    this.desactivarCierreTeclaEsc();
    this.ReporPedRefSi = false;
    this.ReporPedRefNo = false;
    this.btnCargar = true;
    this.cargar = true;
    this.spinner = false;
    this.btnContinuar = true;
    this.continuar = false;
    this.errorcargue = false;
    this.api.consultarPeriodoActivoFIVI().subscribe(PeriAc=>{
      this.PeriodoActivo = PeriAc;
      this.api.EstadoInfParaFuenteFivi(PeriAc.id, localStorage.getItem('idFte')).subscribe(data11=>{
        this.EstadoInfomacionFuente = data11;
        localStorage.setItem("idEstInfFte",data11.id.toString());
      });
    });
    this.RolUsuarioCarga = localStorage.getItem('rol');
    if(localStorage.getItem('rol') == "Fuente"){
      this.api.getUsuarioByUsername(localStorage.getItem("usuario")).subscribe(data=>{
        this.idUsuarioCarga = data.id;
        this.idFuente = data.fuente;
      });
    }
  }

  ngAfterViewInit(){
    this.openmodalperidoact.nativeElement.click();
  }

  public uploadFile(event){
    this.btnCargar = false;
    this.file = (event.target as HTMLInputElement).files[0];

    if(this.file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      this.file.type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      this.file.type=='application/vnd.ms-excel'){
      //console.log("Nombre del archivo: " + this.file.name + " , Tipo: " + this.file.type);
    }else{
      this.toastr.error('Solamente se permiten archivos tipo EXCEL.', 'Error!');
      return;
    }
    let comp = this;
    let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          comp.contenidoDocumento = reader.result.toString();
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
          return error;
        };
  }

  public guardarDocumento(){
    this.btnCargar = true;
    this.cargar = false;
    this.spinner = true;
    this.api.cargarArchivoCMFIVI(this.idUsuarioCarga, this.idFuente, this.file, this.contenidoDocumento ).subscribe(
      result => {
        this.RespuestaCargueMasivo = result;
        if(result.estado == "OK"){
          this.btnContinuar = false;
          this.spinner = false;
          this.errorcargue = false;
          this.continuar = true;
          this.EstadoInfomacionFuente.estado = "En cargue";
          this.api.GuardarEstadoInformacionFivi(this.EstadoInfomacionFuente).subscribe(Result1=>{
            if(Result1){
              this.toastr.success(result.mensaje,result.estado + '!');
            }
          });
        } else if (result.estado == "ERROR"){
          this.btnCargar = false;
          this.cargar = true;
          this.spinner = false;
          this.errorcargue = true;
          this.toastr.error(result.mensaje,result.estado + '!');
        }
      }, error => {
        if(error.status == 500){
          this.toastr.error('Interno: informar atención usuario.','Error!');
        } else {
          this.toastr.error('Cargue incorrecto.','Error!');
        }
      }
    );
  }

  download(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargue"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_.xlsx");
    this.ngOnInit();
  }

  siguienteModulo(){
    this.router.navigate(['novedades']);
  }

  IrNovedades(){
    const isReportPending = this.ReporPedRefSi && !this.ReporPedRefNo;
    const isNoReportSelected = !this.ReporPedRefSi && this.ReporPedRefNo;
    const isBothReportOptionsSelected = this.ReporPedRefSi && this.ReporPedRefNo;
    const isNoReportOptionsSelected = !this.ReporPedRefSi && !this.ReporPedRefNo;

    if (isReportPending) {
      this.carguemasivofuenteService.validarSiFuenteFiviPuedeReportarEnPeriodo(this.idUsuarioCarga, null, this.PeriodoActivo.id).subscribe(result => {
        if (result) {
          if (result.permitido) {
            this.toastr.success(result.mensaje, result.tituloMensaje);
            this.closemodalperidoact.nativeElement.click();
          }else{
            this.toastr.error(result.mensaje, result.tituloMensaje);
          }
        }
      });
    } else if (isNoReportSelected) {
      this.closemodalperidoact.nativeElement.click();
      this.router.navigate(['novedades']);
    } else if (isBothReportOptionsSelected) {
      this.toastr.warning('Seleccione solo una opción.', 'Advertencia!');
    } else if (isNoReportOptionsSelected) {
      this.toastr.warning('Seleccione una opción.', 'Advertencia!');
    }
  }

  private desactivarCierreTeclaEsc() {
    const modalElement = document.getElementById('modal-confirma');
    if (modalElement) {
      modalElement.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  exportarExcel(idTabla:string){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById(idTabla));
    XLSX.utils.book_append_sheet(workbook, ws1, idTabla);
    XLSX.writeFile(workbook, idTabla+".xlsx");
  }




}
